"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewsProvider = void 0;
var react_1 = __importDefault(require("react"));
var uuid_1 = require("uuid");
var ViewComponent_1 = __importDefault(require("./component/ViewComponent"));
var Contexts_1 = require("./Contexts");
exports.ViewsProvider = function (props) {
    return (react_1.default.createElement(Contexts_1.AppContext.Consumer, null, function (app) {
        if (!app) {
            return;
        }
        return props.children(app.views);
    }));
};
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.clients = [];
        _this.existingSharedViews = [];
        _this.viewEvents = new Map();
        _this.cleanUpFunctions = [];
        _this.render = function () {
            return !_this.props.paused && (react_1.default.createElement(Contexts_1.AppContext.Provider, { value: _this }, _this.props.children()));
        };
        _this.componentDidMount = function () {
            if (_this.props.transportIsClient) {
                _this.addClient(_this.props.transport);
            }
        };
        _this.componentWillUnmount = function () {
            _this.cleanUpFunctions.forEach(function (f) { return f(); });
        };
        _this.addClient = function (client) {
            _this.clients.push(client);
            _this.registerSocketListener(client);
        };
        _this.removeClient = function (client) {
            _this.clients = _this.clients.filter(function (currentClient) { return currentClient !== client; });
        };
        _this.registerSocketListener = function (client) {
            var requestViewsTreeHandler = function () {
                client.emit("update_views_tree", {
                    views: _this.existingSharedViews,
                });
            };
            client.on("request_views_tree", requestViewsTreeHandler);
            var requestEventHandler = function (_a) {
                var eventArguments = _a.eventArguments, requestedEventUid = _a.eventUid, currentEventUid = _a.uid;
                var handler = _this.viewEvents.get(requestedEventUid);
                if (!handler) {
                    throw new Error("the client is trying to access an event that does not exist");
                }
                var eventResult = handler.apply(void 0, eventArguments);
                if (eventResult instanceof Promise) {
                    eventResult.then(function (result) {
                        client.emit("respond_to_event", {
                            data: result && JSON.parse(JSON.stringify(result)),
                            uid: currentEventUid,
                            eventUid: requestedEventUid,
                        });
                    });
                }
                else {
                    client.emit("respond_to_event", {
                        data: eventResult && JSON.parse(JSON.stringify(eventResult)),
                        uid: currentEventUid,
                        eventUid: requestedEventUid,
                    });
                }
            };
            client.on("request_event", requestEventHandler);
            _this.cleanUpFunctions.push(function () {
                if (client.off) {
                    client.off("request_views_tree", requestViewsTreeHandler);
                    client.off("request_event", requestEventHandler);
                }
            });
        };
        _this.generateViews = function () {
            var views = _this.viewsObject;
            var viewsNames = Object.keys(views);
            var generatedViews = {};
            viewsNames.forEach(function (viewName) {
                generatedViews[viewName] = (function (props) { return (react_1.default.createElement(ViewComponent_1.default, { name: viewName, props: props })); });
            });
            return generatedViews;
        };
        _this.updateRunningView = function (viewData) {
            if (!_this.server) {
                return;
            }
            var childIndex = viewData.childIndex, isRoot = viewData.isRoot, name = viewData.name, parentUid = viewData.parentUid, uid = viewData.uid;
            var newProps = Object.keys(viewData.props)
                .filter(function (name) {
                return !["children", "key"].includes(name) &&
                    viewData.props[name] !== undefined;
            })
                .map(function (name) {
                var prop = viewData.props[name];
                if (typeof prop === "function") {
                    return {
                        name: name,
                        type: "event",
                        uid: _this.registerViewEvent(prop),
                    };
                }
                else {
                    return {
                        name: name,
                        type: "data",
                        data: JSON.parse(JSON.stringify(prop)),
                    };
                }
            });
            var existingView = _this.existingSharedViews.find(function (view) { return view.uid === uid; });
            var result = {
                childIndex: childIndex,
                isRoot: isRoot,
                name: name,
                parentUid: parentUid,
                uid: uid,
                props: newProps,
            };
            if (!existingView) {
                _this.existingSharedViews.push(result);
                _this.server.emit("update_view", {
                    view: __assign(__assign({}, result), { props: {
                            delete: [],
                            merge: [],
                            create: result.props,
                        } }),
                });
            }
            else {
                var createProps_1 = [];
                var deleteProps_1 = [];
                var newPropsNames_1 = newProps.map(function (newProp) { return newProp.name; });
                existingView.props = existingView.props.filter(function (existingProp) {
                    if (newPropsNames_1.includes(existingProp.name)) {
                        return true;
                    }
                    deleteProps_1.push(existingProp.name);
                    if (existingProp.type === "event") {
                        _this.viewEvents.delete(existingProp.uid);
                    }
                });
                newProps.forEach(function (newProp) {
                    var existingProp = existingView.props.find(function (prop) { return prop.name === newProp.name; });
                    if (existingProp) {
                        if (newProp.type === "event" && existingProp.type === "event") {
                            if (_this.viewEvents.get(newProp.uid) ===
                                _this.viewEvents.get(existingProp.uid)) {
                                _this.viewEvents.delete(newProp.uid);
                            }
                            else {
                                existingProp.uid = newProp.uid;
                                createProps_1.push(newProp);
                            }
                        }
                        else if (newProp.type === "data" && existingProp.type === "data") {
                            if (JSON.stringify(newProp.data) !== JSON.stringify(existingProp.data)) {
                                createProps_1.push(newProp);
                                existingProp.data = newProp.data;
                            }
                        }
                        else if (newProp.type !== existingProp.type) {
                            existingView.props.splice(existingView.props.findIndex(function (prop) { return prop.name === newProp.name; }), 1, __assign({}, newProp));
                            createProps_1.push(newProp);
                        }
                    }
                    else {
                        createProps_1.push(newProp);
                        existingView.props.push(newProp);
                    }
                });
                if (deleteProps_1.length > 0 || createProps_1.length > 0) {
                    _this.server.emit("update_view", {
                        view: __assign(__assign({}, result), { props: {
                                create: createProps_1,
                                delete: deleteProps_1,
                                merge: [],
                            } }),
                    });
                }
            }
        };
        _this.deleteRunningView = function (uid) {
            var runningViewIndex = _this.existingSharedViews.findIndex(function (view) { return view.uid === uid; });
            if (runningViewIndex !== -1) {
                var deletedView = _this.existingSharedViews.splice(runningViewIndex, 1)[0];
                deletedView.props.forEach(function (prop) { return prop.type === "event" && _this.viewEvents.delete(prop.uid); });
                if (!_this.server) {
                    return;
                }
                _this.server.emit("delete_view", { viewUid: uid });
            }
        };
        _this.registerViewEvent = function (event) {
            var eventUid = uuid_1.v4();
            _this.viewEvents.set(eventUid, event);
            return eventUid;
        };
        _this.viewsObject = props.views;
        _this.server = props.transport;
        _this.views = _this.generateViews();
        return _this;
    }
    return App;
}(react_1.default.Component));
exports.default = App;
//# sourceMappingURL=App.js.map